// Import all actions
import * as actions from "../actions/authActions";

export const initialState = {
  isLoggedIn: false,
  jwt: "",
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOG_IN:
      return { ...state, isLoggedIn: true, jwt: action.payload };
    case actions.LOG_OUT:
      return { isLoggedIn: false, jwt: "" };
    case actions.REFRESH_TOKEN:
      return { ...state, jwt: action.payload };
    default:
      return state;
  }
}
